export const addCtasToEvents = (listingCtas = [], events = []) => {
  return [...listingCtas, ...events]
    .map(item => ({
      ...item,
      startDate: item.startDate || item.listingCta?.startDate,
    }))
    .sort((a, b) => new Date(a.startDate) - new Date(b.startDate));
};
